<template>
  <div class="page testimonials light">
    <div class="inner">
      <h1>Testimonials</h1>
        <div class="quote">"Anyone in the North/East Devon or West Somerset area, check out this studio. Beautiful location and great guys to work with." </div>
        <div class="quote-by">- <strong>Jamie Hartnoll</strong> (The Tone Station, Hartnolls Guitar Centre)</div>


        <div class="quote">"Copse Corner is everything I need from a studio.
                A relaxed atmosphere and quiet, comfortable surroundings mean I can really get a lot of work done there. Rob's expertise and attention to detail means I can concentrate on the creative stuff and not worry about anything else. Lovely sounding and well-maintained piano is a huge bonus for me.
                The studio cat is very friendly too!"</div>
        <div class="quote-by">- <strong>Alan Welch</strong> (<a href="https://www.facebook.com/Soulcraft6">Soulcraft</a>)
                </div>


        <div class="quote">"Preparing and recording my project at Copse Corner with Rob was amazing! I had so much fun and had every need catered for! Working in a relaxed yet professional atmosphere was exactly what I needed to bring my songs to life, and they were recorded with amazing quality. The Jaffa cakes were a bonus too!
                I will definitely recommend Rob's services to everyone!"</div>
        <div class="quote-by">
                - <strong>Leilah Hoinville</strong> (aka Hoinville)<br />
                Listen: <a href="https://soundcloud.com/dogstaar/wishfulthinking">Wishful Thinking</a><br />
                Read: <a href="http://www.edmsauce.com/2014/09/08/dogst%CE%BB%CE%BBr-wishful-thinking-close-eyes-ft-leilah-hoinville/">EDMSauce review</a>
        </div>

        <div class="quote">"I've had the pleasure of working at Rob's studio. Me and a few other Nottingham artists were fortunate enough to stay over for a couple of days and have two long sessions writing, recording and enjoying this space. Incredibly professional and very welcoming. Rob Watson kindly made sure we were as comfortable as possible when it came to the set up of recording, in terms of setting up mood lighting, positioning of microphones to our specifications and reassuring we were ok to carry on recording if we were struggling to get a certain take. 
Can't wait to go back!"</div>
        <div class="quote-by">- <strong><a href="http://www.ninasmithmusic.com">Nina Smith</a></strong> </div>

        <div class="quote">"Rob's studio caters for professional recording services including a comfortable space to write and record music. I was very humbled by Rob's hospitality and occasional checks on the artists, including myself and the other musicians I was present with, to see if we were comfortable with our recordings. 
Definitely recommend to any musician!"</div>
        <div class="quote-by"> - <strong>'Motormauf'</strong> (<a href="https://www.facebook.com/WeAreJustJames">Just James</a>)</div>

        <div class="quote">"Really bloody handy with a microphone this chap, achieved some incredible drum takes. He managed to knock up a low frequency capture device from spare parts in about 3 minutes, which combined with an AKG D112 has resulted in the best recorded bass drum sound I have ever heard. Highly recommended!"</div>
        <div class="quote-by"> - <strong>Charlie Green</strong> (<a href="https://www.facebook.com/nairobitheband">Nairobi</a>)</div>

        <div class="quote">"Always a delight to work in professional surroundings, and with people who make the process enjoyable and rewarding. A great studio and real value for your money."</div>
        <div class="quote-by">- <strong>Trevor Reynolds</strong></div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'testimonials'
}
</script>

<style scoped lang="scss">
.testimonials{
  
  min-height: 100vh;

}
.testimonials img{
    width: 100%;
    height: 100%;
    object-fit: cover;
    box-sizing: border-box;
}
.inner{
  max-width: 1200px;
  margin: 0 auto;
}

.quote{
  border-left:8px solid #999;
  padding:0.5em;
  font-style: italic;
}
.quote-by{
  text-align: right;
  margin-bottom:5em;
}
h1{
  color: black;
  margin-top:2em;
  margin-bottom: 1em;
}
</style>
